var TEMPLATE_URL = require('./capture.export.selector.html');
angular.module('ikeweb.spike.capture').directive('captureExportSelector', ['events', 'billingService',

    function(EVENTS, billingService) {

        return {
            restrict: 'E',
            replace: true,
            templateUrl: TEMPLATE_URL,
            scope: {
                capture: '='
            },
            link: function($scope) {
                $scope.dismissEvent = EVENTS.EXPORT.DISMISS_EXPORT_SELECTOR;
                $scope.displayEvent = EVENTS.EXPORT.DISPLAY_EXPORT_SELECTOR;
                $scope.selected = $scope.COMPOSITE = 'COMPOSITE';
                $scope.DESKEWED = 'DESKEWED';
                $scope.IMAGEONLY = 'IMAGEONLY';

                $scope.select = function(value) {
                    $scope.selected = value;
                };


                var canDeskew = false;
                billingService.isOnPremium().then(function(isPro) {
                    canDeskew = isPro;
                });
                $scope.canDeskew = function() {
                    return canDeskew;
                };

                $scope.download = function() {
                    $scope.$emit(EVENTS.EXPORT.DOWNLOAD[$scope.selected]);
                    $scope.$emit(EVENTS.EXPORT.DISMISS_EXPORT_SELECTOR);
                };
            }
        };
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/spike/capture/capture.export.selector.directive.js
// module id = 516
// module chunks = 0